import ProtectedRoutes from './ProtectedRoute';

export default ProtectedRoutes;
